import {useCoreState} from 'store';
import {useInputMode} from 'store/UserInput';
import {useMainScreenKeyboardInput} from 'ui/utils/core';
import {selectHandlerFor} from './selectHandler';

export function useFutureDailyAmount(): MoneyAmount {
  const input = useMainScreenKeyboardInput();
  const state = useCoreState();
  const mode = useInputMode();

  const handleSignal = selectHandlerFor(mode);
  return handleSignal(state, input);
}
